export {default as minpath} from 'node:path'
